import { Outlet, useLocation } from 'react-router-dom';
// @mui
import { Container, Stack } from '@mui/material';
// hooks
import useMerchant from 'src/hooks/useMerchant';
// components
import Page from 'src/components/Page';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { getProgramMenu } from './dashboard/navbar/NavConfig';
import ProgramTopNavWrapper from './dashboard/navbar/ProgramTopNavWrapper';

const ProgramsLayout: React.FC<{ currentPath?: string }> = ({ currentPath }) => {
  const { merchant, isMerchantLoading } = useMerchant();
  const { pathname } = useLocation();

  // const isEmployeeEngagementPage = pathname.includes('employee') && pathname.includes('engagement');
  // const hideDatePicker = !isMerchantLoading && isEmployeeEngagementPage;
  
  const isEmployeesPage = pathname.includes('employees');
  const isEmployeeEngagementPage = pathname.includes('employee') && pathname.includes('engagement');
  const showDatePicker = !isMerchantLoading && !isEmployeesPage && !isEmployeeEngagementPage;

  const menuItems = merchant?.programmes && getProgramMenu(merchant.programmes);
  const currentOpenedProgram = menuItems?.find((el) => pathname?.includes(el?.path));
  const currentLocation = currentOpenedProgram?.children?.find((el) => el?.path === pathname);

  const pageTitle = currentOpenedProgram ? `${currentOpenedProgram.title}` : 'Loading...';

  const getBreadcrumbs = (currentPath?: string, root?: string) => {
    const baseProgramLinks = {
      title: pageTitle,
      links: [
        { name: 'Programmes' },
        { name: pageTitle },
        { name: currentLocation?.title || 'Loading...' },
      ]
    };

    if (currentPath && root) {
      return { title: currentPath, links: [{ name: root }, { name: currentPath }] };
    } else {
      return baseProgramLinks;
    }
  };

  const breadcrumbs = getBreadcrumbs(currentPath, 'Programmes');

  return (
    <Page title={breadcrumbs.title}>
      <Container maxWidth={false}>
        <HeaderBreadcrumbs links={breadcrumbs.links} />

        <Stack direction={'column'} spacing={1}>
          <ProgramTopNavWrapper
            navigation={currentOpenedProgram?.children}
            showDatePicker={showDatePicker}
          />

          <Outlet />
        </Stack>
      </Container>
    </Page>
  );
};

export default ProgramsLayout;
